import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const HEADER_FILL = { type: 'pattern', pattern: 'solid', fgColor: { argb: '7B241C' } };
const HEADER_FONT = { bold: true, color: { argb: 'FFFFFF' }, size: 11 };
const TITLE_FONT = { bold: true, size: 14, color: { argb: '7B241C' } };
const THIN_BORDER = {
  top: { style: 'thin' },
  bottom: { style: 'thin' },
  left: { style: 'thin' },
  right: { style: 'thin' }
};

const COLUMN_WIDTHS = [16, 22, 22, 40];
const HEADER_LABELS = ['Matricule', 'Nom', 'Prénom', 'Motif'];

const EXAMPLES = [
  ['001', 'DOE', 'JOHN', 'Départ à la retraite'],
  ['014', 'MARTIN', 'PAUL', 'Fin de contrat'],
  ['027', 'KOFFI', 'AMA', 'Démission']
];

const NOTES = [
  'Note',
  'Seule la colonne « Matricule » est obligatoire.',
  'Le matricule doit correspondre à un agent (ou ayant-droit) existant de la société choisie.',
  'Débaucher un agent archive automatiquement tout son foyer (ayants-droit).',
  'La colonne « Motif » est facultative (indicative). Un motif global peut aussi être saisi à l’import.'
];

/**
 * Génère et télécharge le modèle Excel de débauche en masse
 * (`modele_debauche.xlsx`).
 *
 * @returns {Promise<void>}
 */
export const downloadDebaucheTemplate = async () => {
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet('MODELE_DEBAUCHE');

  ws.columns = COLUMN_WIDTHS.map((width) => ({ width }));

  ws.mergeCells(1, 1, 1, 4);
  const titleCell = ws.getRow(1).getCell(1);
  titleCell.value = 'DÉBAUCHE EN MASSE — FUNTOA SMIE';
  titleCell.font = TITLE_FONT;
  titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
  ws.getRow(1).height = 26;

  const headerRowNum = 3;
  const headerRow = ws.getRow(headerRowNum);
  headerRow.height = 22;
  HEADER_LABELS.forEach((h, i) => {
    const cell = headerRow.getCell(i + 1);
    cell.value = h;
    cell.fill = HEADER_FILL;
    cell.font = HEADER_FONT;
    cell.border = THIN_BORDER;
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
  });

  EXAMPLES.forEach((data, i) => {
    const row = ws.getRow(headerRowNum + 1 + i);
    data.forEach((val, j) => {
      const cell = row.getCell(j + 1);
      cell.value = val;
      cell.border = THIN_BORDER;
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });
  });

  const noteStart = headerRowNum + 1 + EXAMPLES.length + 2;
  NOTES.forEach((text, i) => {
    const row = ws.getRow(noteStart + i);
    ws.mergeCells(noteStart + i, 1, noteStart + i, 4);
    const cell = row.getCell(1);
    cell.value = text;
    if (i === 0) {
      cell.font = { bold: true, size: 12, underline: true, color: { argb: 'C0392B' } };
    } else {
      cell.font = { size: 10 };
    }
  });

  const buffer = await wb.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), 'modele_debauche.xlsx');
};

export default downloadDebaucheTemplate;
